export type Review = {
  quote: string
  name: string
  role: string
  city: string
  country: string
}

/**
 * Reseñas de compradores de Solar PV & Battery Diagnostic Pro.
 * Vacío a propósito: el producto todavía no tiene compradores. La sección
 * "From the field" no se muestra hasta que se carguen reseñas reales acá.
 */
export const reviews: Review[] = []
